<template>
  <div id="login">
      <div class="titlelogin">
        <div>HI,</div>
        <div>欢迎定制您的个人专属工具</div>
      </div>
      <div class="boxlogin">
        <div>请选择:</div>
        <div class="enter">
          <div @click="skipFn()">
              <img src="@/assets/tab1.png"/>
          </div>
          <div @click="mFn()">
              <img src="@/assets/tab2.png"/>
          </div>
          <div @click="mFn()">
              <img src="@/assets/tab3.png"/>
          </div>
          <div @click="mFn()">
              <img src="@/assets/tab4.png"/>
          </div>
        </div>
      </div>
      <div class="footerlogin">
            <img src="@/assets/btm.png"/>
            北京博理汇信息技术有限公司
      </div>

      <p class="qita"><a style="color:#000;" href="https://beian.miit.gov.cn/">京ICP备17050969号-3</a></p>
  </div>
</template>

<script>
import { Dialog, Toast } from 'vant';
export default {
  data() {
    return {
    };
  },
  methods: {
      skipFn(){
          this.$router.push({path:'/info'})
      },
      mFn(){
        Toast.loading({
          duration: 500,
          message: '开发中...',
        });
      },
      loginFn(){

        

        let that = this;
        let params = {
          "username": this.$route.query.code,
        }
        this.$postForm('api/login', params)
        .then((response) => {
            window.sessionStorage.setItem('openid', response.data.data.openId)
            window.sessionStorage.setItem('token', response.headers.authorization)
        }) 
      }
  },
  created() {

    Toast.loading({
      duration: 1000,
      message: '加载中...',
      forbidClick: true,

    });

    if(window.location.href.includes('code')){
        this.loginFn();
        //wx.config({
        //  debug: true, 
        //  appId: 'wx887b5ac7ab70af14', // 必填，公众号的唯一标识
        //  timestamp: '', // 必填，生成签名的时间戳
        //  nonceStr: '', // 必填，生成签名的随机串
        //  signature: '',// 必填，签名
        //  jsApiList: ['chooseWXPay'] // 必填，需要使用的JS接口列表
        //});
        return;
    }
    let appid = "wx887b5ac7ab70af14";
    let redirect_uri = encodeURI(window.location.origin);
    let url = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${redirect_uri}&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect`;
    window.location.href = url;

    





    //wx.config({
    //  debug: true, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
    //  appId: '', // 必填，公众号的唯一标识
    //  timestamp: , // 必填，生成签名的时间戳
    //  nonceStr: '', // 必填，生成签名的随机串
    //  signature: '',// 必填，签名
    //  jsApiList: [] // 必填，需要使用的JS接口列表
    //});
  }

};
</script>
<style scope>
#login .titlelogin{
  font-size: 20px;
  color:#000;
  width:70%;
  margin: 0 auto;
  text-align:left;
  padding-top: 60px;
}
#login .titlelogin div:first-child{
    text-align:left;
}
#login .boxlogin{
  font-size: 18px;
  border: 1px solid #eee;
  border-radius: 10px;
  width: 80%;
  margin: 0 auto;
  margin-top: 50px;
  background:#fff;
}
#login .boxlogin > div:first-child{
    text-align:left;
    padding: 20px;
    color:#000;
    font-weight: 500;

}
#login .boxlogin .enter > div{
  width: 50%;
  padding-bottom: 30px;
  display: inline-block;
}
#login .boxlogin .enter > div img{
  width: 50%;
  margin: 0 auto !important;
}
#login .footerlogin img{
  display: block;
  margin: 0 auto;
  width: 100px;
  margin-bottom: 20px;
}
#login .footerlogin{
  padding-top: 30px;
  background:#fff;
  left:0;
  right:0;
  text-align:center;
  font-size: 15px;
}
.qita{
    position: fixed;
    color: #000;
    bottom: 0;
    display: inline-block;
    left: 0;
    /* width: 100vw; */
    right: 0;
    /* height: 100px; */
    margin: 0 auto;
    text-align: center;
    text-wrap: wrap;
    line-height: 15px;
    padding: 10px;
    font-size: 10px;
}
</style>

